
import { ShareBaseItem } from '../../phoenix/domain';

export interface InProgressItem extends ShareBaseItem {
    inProgress: boolean;
}

export class InProgressItemsDataStore {
    public items: InProgressItem[];

    public clear() {
        this.items.forEach(i => i.inProgress = false);
        this.items = [];
    }

    public setItems(items: ShareBaseItem[]) {
        this.items = items.map((i: InProgressItem) => {
            i.inProgress = true;
            return i;
        });
    }
}


// WEBPACK FOOTER //
// ./src/sharebase-app/dataStores/inProgressItemsDataStore.ts